// Same list as the mobile app's src/types/countryCurrency.ts, so sign-ups
// from the website and the app store the same country and currency codes.
export const COUNTRY_CURRENCY = [
  {
    countryCode: 'US',
    countryName: 'United States',
    currencyCode: 'USD',
    currencyName: 'US Dollar',
    currencySymbol: '$',
  },
  {
    countryCode: 'CA',
    countryName: 'Canada',
    currencyCode: 'CAD',
    currencyName: 'Canadian Dollar',
    currencySymbol: '$',
  },
  {
    countryCode: 'GB',
    countryName: 'United Kingdom',
    currencyCode: 'GBP',
    currencyName: 'Pound Sterling',
    currencySymbol: '£',
  },
  {
    countryCode: 'AU',
    countryName: 'Australia',
    currencyCode: 'AUD',
    currencyName: 'Australian Dollar',
    currencySymbol: '$',
  },
  {
    countryCode: 'NZ',
    countryName: 'New Zealand',
    currencyCode: 'NZD',
    currencyName: 'New Zealand Dollar',
    currencySymbol: '$',
  },
  {
    countryCode: 'EU',
    countryName: 'Eurozone',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },
  {
    countryCode: 'FR',
    countryName: 'France',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },
  {
    countryCode: 'DE',
    countryName: 'Germany',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },
  {
    countryCode: 'ES',
    countryName: 'Spain',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },
  {
    countryCode: 'IT',
    countryName: 'Italy',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },
  {
    countryCode: 'NL',
    countryName: 'Netherlands',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },
  {
    countryCode: 'BE',
    countryName: 'Belgium',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },
  {
    countryCode: 'IE',
    countryName: 'Ireland',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },
  {
    countryCode: 'PT',
    countryName: 'Portugal',
    currencyCode: 'EUR',
    currencyName: 'Euro',
    currencySymbol: '€',
  },

  // 🇸🇦 / 🇵🇰 / your contexts
  {
    countryCode: 'SA',
    countryName: 'Saudi Arabia',
    currencyCode: 'SAR',
    currencyName: 'Saudi Riyal',
    currencySymbol: 'ر.س',
  },
  {
    countryCode: 'PK',
    countryName: 'Pakistan',
    currencyCode: 'PKR',
    currencyName: 'Pakistani Rupee',
    currencySymbol: '₨',
  },

  // Asia
  {
    countryCode: 'IN',
    countryName: 'India',
    currencyCode: 'INR',
    currencyName: 'Indian Rupee',
    currencySymbol: '₹',
  },
  {
    countryCode: 'JP',
    countryName: 'Japan',
    currencyCode: 'JPY',
    currencyName: 'Japanese Yen',
    currencySymbol: '¥',
  },
  {
    countryCode: 'CN',
    countryName: 'China',
    currencyCode: 'CNY',
    currencyName: 'Chinese Yuan',
    currencySymbol: '¥',
  },
  {
    countryCode: 'SG',
    countryName: 'Singapore',
    currencyCode: 'SGD',
    currencyName: 'Singapore Dollar',
    currencySymbol: '$',
  },
  {
    countryCode: 'HK',
    countryName: 'Hong Kong',
    currencyCode: 'HKD',
    currencyName: 'Hong Kong Dollar',
    currencySymbol: '$',
  },
  {
    countryCode: 'AE',
    countryName: 'United Arab Emirates',
    currencyCode: 'AED',
    currencyName: 'UAE Dirham',
    currencySymbol: 'د.إ',
  },

  // Americas
  {
    countryCode: 'MX',
    countryName: 'Mexico',
    currencyCode: 'MXN',
    currencyName: 'Mexican Peso',
    currencySymbol: '$',
  },
  {
    countryCode: 'BR',
    countryName: 'Brazil',
    currencyCode: 'BRL',
    currencyName: 'Brazilian Real',
    currencySymbol: 'R$',
  },

  // Africa
  {
    countryCode: 'ZA',
    countryName: 'South Africa',
    currencyCode: 'ZAR',
    currencyName: 'South African Rand',
    currencySymbol: 'R',
  },

  // Nordics / others
  {
    countryCode: 'SE',
    countryName: 'Sweden',
    currencyCode: 'SEK',
    currencyName: 'Swedish Krona',
    currencySymbol: 'kr',
  },
  {
    countryCode: 'NO',
    countryName: 'Norway',
    currencyCode: 'NOK',
    currencyName: 'Norwegian Krone',
    currencySymbol: 'kr',
  },
  {
    countryCode: 'DK',
    countryName: 'Denmark',
    currencyCode: 'DKK',
    currencyName: 'Danish Krone',
    currencySymbol: 'kr',
  },
  {
    countryCode: 'CH',
    countryName: 'Switzerland',
    currencyCode: 'CHF',
    currencyName: 'Swiss Franc',
    currencySymbol: 'Fr',
  },
];
